var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return ((_vm.bubbleText))?_c('div',{staticClass:"bubble-button-container"},[_c('div',{staticClass:"before-button bubble-button"},[_vm._v(_vm._s(_vm.bubbleText))])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }